import React from "react";

import { Typography, makeStyles } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
  },
  heading: {
    width: "100%",
    color: "#000000",
    fontWeight: "500",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  subHeading: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "80%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "0.85rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      letterSpacing: "0.016rem",
    },
  },
  illustrationSizer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "280px",
      width: "280px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "320px",
      width: "320px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "352px",
      width: "352px",
    },
    [theme.breakpoints.only("md")]: {
      height: "384px",
      width: "384px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "512px",
      width: "512px",
    },
    [theme.breakpoints.only("xl")]: {
      height: "512px",
      width: "512px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "768px",
      width: "768px",
    },
  },
  divider: {
    width: "100%",
    maxWidth: "70%",
    bgcolor: "666666",
  },
  price: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      margin: "1rem 0rem 1rem 0rem",
    },
    fontWeight: 400,
    fontSize: "1.125rem",
    lineHeight: "1.37rem",
    color: "#000000",
  },
  Icon: {
    marginRight: "0.5rem",
  },
}));

const Product = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <div className={classes.text}>
          <Typography variant="h5" component="span" className={classes.heading}>
            {props.productname}
          </Typography>
          <Divider className={classes.divider} />
          <Typography
            variant="body2"
            component="span"
            className={classes.subHeading}
          >
            {props.productdescription}
          </Typography>
        </div>
        {/* <div className={classes.price}>
          <img
            src="/images/icons/misc/rupees.svg"
            alt={AppConfig.imageAltText}
            width={20}
            height={20}
            loading="lazy"
            referrerPolicy="no-referrer"
            longdesc="https://advisory.beegru.com"
            className={classes.Icon}
          />
          {props.price}
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default Product;
